import { Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { ProfessionalServiceItem } from '@interfaces/professional-booking';
import { CurrencyFormatPipe } from '@app/shared/pipes/currency-format.pipe';

/** A professional service as a card linking to its own page (booking plan §1.1). */
@Component({
    selector: 'app-professional-service-card',
    templateUrl: './professional-service-card.component.html',
    styleUrls: ['./professional-service-card.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, MatIconModule, TranslateModule, CurrencyFormatPipe]
})
export class ProfessionalServiceCardComponent {
    @Input() service: ProfessionalServiceItem;
    /** The professional's slug (or id); defaults to the card's own `service.professional`. */
    @Input() professionalSlug: string;
    /** Show which professional offers the service (category listing). */
    @Input() showProfessional = false;

    readonly noImage = 'assets/images/nologo.png';

    constructor(public translate: TranslateService, public translateHelper: TranslateHelper) { }

    get link(): string[] {
        const professional = this.professionalSlug || this.service?.professional?.slug || this.service?.professional?._id;
        return [`/${this.translate.currentLang}`, 'professional', professional, this.service?.seo?.slug || this.service?._id];
    }

    get image(): string {
        return this.service?.images?.[0]?.url || this.noImage;
    }

    get priceSuffixKey(): string {
        if (this.service?.timeType === 'time_slots') return 'per_slot_suffix';
        return this.service?.priceMode === 'per_booking' ? 'per_booking_suffix' : 'per_day_suffix';
    }
}
